export class InvoiceInfo {
    PatientId:number;
    PatientTypeId:number;
    EncounterId:number;
}